<template>
  <v-checkbox v-model="conditions" :required="required" :disabled="disabled" :rules="rules">
        <span slot="label">
            Ich habe die
          <!--<conditions-dialog>
              <a slot="activator">AGB</a>
          </conditions-dialog>{{ contestRules ? ',' : ' und ' }}-->
            <a href="/privacy" target="_blank">Datenschutzerklärung</a>
            {{ contestRules ? 'und' : '' }}
            <contest-rules-dialog v-if="contestRules">
                <a slot="activator" v-t="'contest_rules'"></a>
            </contest-rules-dialog>
            gelesen und akzeptiere sie{{ required ? '*' : '' }}
        </span>
  </v-checkbox>
</template>

<script>
import ContestRulesDialog from '../dialogs/ContestRulesDialog';

export default {
  name: "AcceptConditions",
  components: {
    'contest-rules-dialog': ContestRulesDialog,
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    contestRules: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value() {
      this.conditions = this.value;
    },
    conditions() {
      this.$emit('update:value', this.conditions);
    }
  },
  data: () => ({
    conditions: false,
    rules: []
  }),
  mounted() {
    this.rules.push(
        (v) => !!v || 'AGB' + (this.contestRules ? ', Datenschutz und Wettkampfregeln' : ' und Datenschutz') + ' müssen akzeptiert werden'
    );
  }
}
</script>
